import { InfoFillCircleIcon } from '@/components/ui/icons'
import { useTranslation } from '@/translations/i18n'

/**
 * Pre-download warning: some included rows will export with empty
 * sf_user_id / OwnerId columns because no owner in their cascade has a
 * backfilled Salesforce user ID. A heads-up, never a blocker: the operator
 * assigns owners manually in Salesforce after the upload.
 *
 * Driven by `owner_id === null` on included rows — the strict null, so a
 * response that simply omits the field reports nothing instead of everything.
 */
export function ExportOwnerBanner({ count }: { count: number }) {
	const { t } = useTranslation()
	return (
		<div className='flex items-start gap-3 rounded-airbnb-2xl border border-orange-300 px-6 py-5'>
			<InfoFillCircleIcon className='mt-0.5 size-5 shrink-0 text-orange-600' />
			<div className='flex flex-col gap-1 text-sm'>
				<p className='font-medium text-neutral-900'>
					{t('marquee:export_owner_banner_title')}
				</p>
				<p className='max-w-3xl text-neutral-500'>
					{t('marquee:export_owner_banner_body', { count })}
				</p>
			</div>
		</div>
	)
}
